import { useResize } from 'stimulus-use'
import { Controller } from 'stimulus'
import { getScrollParent } from '~/common/helpers/scroll_parent'
import { debounce } from 'throttle-debounce'

export default class extends Controller {
  connect() {
    this.autoScroll = true
    this.scrollParent = getScrollParent(this.element)
    useResize(this)
    // Content growing isn't the only thing that pushes the last message out of sight — the
    // composer gains a line, a sidebar opens, a phone keyboard appears. Those resize the
    // scroll parent, not the thread, so watch it too or we stay stranded above the bottom.
    this.viewportObserver = new ResizeObserver(() => this.resize())
    this.viewportObserver.observe(this.scrollParent)
    this.scrollParent.addEventListener('scroll', this.updateAutoScrollState)
    // Open at the latest message rather than waiting for the first resize to take us there.
    this.scrollToBottom()
  }

  disconnect() {
    this.viewportObserver.disconnect()
    this.scrollParent.removeEventListener('scroll', this.updateAutoScrollState)
  }

  updateAutoScrollState = debounce(10, () => {
    if (this.isNearBottom()) {
      this.autoScroll = true
      return
    }

    // Anything that lands after we pinned — an image, a player, a streamed reply — leaves
    // us short of the bottom without the reader having touched a thing. Only a scroll that
    // moved away from where we put it means they want to stay where they are.
    if (this.scrollParent.scrollTop === this.pinnedScrollTop) return

    this.autoScroll = false
  })

  resize() {
    if (!this.autoScroll) return

    this.scrollToBottom()
  }

  scrollToBottom() {
    this.scrollParent.scrollTop = this.scrollParent.scrollHeight
    this.pinnedScrollTop = this.scrollParent.scrollTop
  }

  isNearBottom(threshold = 1) {
    return (
      this.scrollParent.scrollHeight -
        this.scrollParent.scrollTop -
        this.scrollParent.clientHeight <=
      threshold
    )
  }
}
